import * as React from 'react';
import { Button } from '../common';
import {
    Avatar,
    Grid2 as Grid,
} from '@mui/material';
import { UserTitleRole } from '../../enums';
import { UserTitleRoleSelect } from './UserTitleRoleSelect';
import { BaseDialog, BaseDialogProps } from '../common/dialog/BaseDialog';

interface Props extends BaseDialogProps {
    readonly open: boolean;
    readonly selectedUser: Entities.UserTitleRoleData;
    readonly onUpdate: (role: UserTitleRole) => void;
}

interface State {
    readonly role: UserTitleRole;
}

export class EditUserTitleDialog extends BaseDialog<Props, State> {
    state: State = {
        role: UserTitleRole.NoRole,
    };

    componentDidMount() {
        const { selectedUser } = this.props;
        this.setState({ role: selectedUser.userTitleRole });
    }

    componentDidUpdate(prevProps: Props) {
        const { selectedUser } = this.props;
        if (selectedUser.userTitleRole !== prevProps.selectedUser.userTitleRole) {
            this.setState({ role: selectedUser.userTitleRole });
        }
    }

    protected renderContent(): React.JSX.Element {
        const { role } = this.state;

        return (
            <Grid container={true} justifyContent="center" alignItems="center" spacing={0}>
                <Grid size={12}>
                    <UserTitleRoleSelect
                        label="Role"
                        role={role}
                        updateRole={this.updateRole}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderTitle(themeMode: ThemeMode): React.JSX.Element {
        const { username, name, picture } = this.props.selectedUser;
        return (
            <Grid container={true} justifyContent="center" alignItems="center" spacing={0}>
                <Grid size={12} style={{ display: 'grid', gridColumnGap: 10, gridAutoFlow: 'column', justifyContent: 'flex-start'}}>
                    <Avatar alt="Remy Sharp" src={picture} style={{ height: 40, width: 40 }} />
                    {name !== '' && (
                        <Grid container={true}>
                            <Grid size={12}>
                                <div style={{ fontSize: 14 }} >
                                    {name}
                                </div>
                            </Grid>
                            <Grid size={12}>
                                <div style={{ fontSize: 12 }} >
                                    {username}
                                </div>
                            </Grid>
                        </Grid>
                    )}
                    {name === '' && (
                        <Grid container={true}>
                            <Grid size={12}>
                                <div style={{ color: 'rgba(0,0,0,.87)', fontSize: 14 }} >
                                    {username}
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Update role" onClick={this.onCreate} variant="contained"disabled={!this.validate()} />
        );
    }

    private validate() {
        const { role } = this.state;
        return !(role === UserTitleRole.NoRole || role === this.props.selectedUser.userTitleRole);
    }

    private updateRole = (role: UserTitleRole) => this.setState({ role });

    private onCreate = () => {
        const { role } = this.state;
        if (!this.validate()) {
            return;
        }
        this.props.onUpdate(role);
        this.onClose();
    };
}
